export default __webpack_public_path__ + "static/leaseweb-logo.681c7b4c.svg";